import PubSub from 'pubsub-js';

const $html = $('html');
const $targetIntersection = '.content.-news .-intersection';
const $targetParent = $('.content.-news');
const $contentTable = $('.content__table', $targetParent);
const $contentLink = $('.content__link', $targetParent);

const ACTIVE_TIME = 1500;

const intersection = () => {
    const targets = document.querySelectorAll(`${$targetIntersection}`);

    const options = {
      root: null,
      rootMargin: '0px 0px',
      threshold: 0.5,
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (!$(entry.target).hasClass('-intersectionIsEntry')) {
            $(entry.target).addClass('-intersectionIsEntry');
          }
        }
      });
    }, options);

    targets.forEach(target => {
      observer.observe(target);
    });
};

PubSub.subscribe('init', () => {
    const device = $html.data('device');
    if (device === 'mobile') {
        intersection();
    }
});

PubSub.subscribe('top.news.show', () => {
  $contentTable.addClass('-intersectionIsEntry');
  $contentLink.addClass('-intersectionIsEntry');

  setTimeout(() => {
    $targetParent.addClass('-active');
  }, ACTIVE_TIME);
});

PubSub.subscribe('top.news.hide', () => {
  $contentTable.removeClass('-intersectionIsEntry');
  $contentLink.removeClass('-intersectionIsEntry');

  $targetParent.removeClass('-active');
});